import { Tab } from "@fluentui/react-components";
import {
    CalendarPerson20Regular,
    CalendarStar20Regular,
} from "@fluentui/react-icons";
import { Flex, Loader } from "@fluentui/react-northstar";
import { TabListStyle, TeamBadge } from "../Parent";
import { TABS_LEAVE } from "../utils/functions";

const LeaveTabs = ({
    activeTab,
    setActiveTab,
    isManager,
    isDelegatedForLeave,
    setCleanParams,
    isFetchingCounterBadge,
    teamBadge,
    isRH,
}) => {
    return (
        <TabListStyle defaultSelectedValue={activeTab} appearance="transparent">
            <Tab
                value={TABS_LEAVE.absences}
                icon={<CalendarStar20Regular />}
                content={TABS_LEAVE.absences}
                text
                onClick={() => {
                    setActiveTab(TABS_LEAVE.absences);

                    setCleanParams("");
                    return;
                }}
            />
            {/* si manager ou bien ils lui ont attribués un ROLE manager */}
            {(isManager || isDelegatedForLeave) && (
                <Tab
                    icon={<CalendarPerson20Regular />}
                    value={TABS_LEAVE.teamCalendar}
                    text
                    onClick={() => {
                        setActiveTab(TABS_LEAVE.teamCalendar);

                        setCleanParams("");
                        return;
                    }}
                >
                    <Flex gap="gap.small">
                        {TABS_LEAVE.teamCalendar}
                        {isFetchingCounterBadge ? (
                            <Loader size="smallest" />
                        ) : (
                            <TeamBadge
                                content={
                                    teamBadge
                                        ? teamBadge?.leaves_to_approve
                                        : "0"
                                }
                                styles={{
                                    backgroundColor:
                                        activeTab === TABS_LEAVE.teamCalendar
                                            ? "#d1d1d1 !important"
                                            : "inherit",
                                }}
                            />
                        )}
                    </Flex>
                </Tab>
            )}

            {isRH && (
                <Tab
                    value={TABS_LEAVE.societyCalendar}
                    icon={<CalendarPerson20Regular />}
                    content={TABS_LEAVE.societyCalendar}
                    text
                    onClick={() => {
                        setActiveTab(TABS_LEAVE.societyCalendar);

                        setCleanParams("");
                    }}
                />
            )}
        </TabListStyle>
    );
};

export default LeaveTabs;
